import { register } from 'register-service-worker'
import { LocalStorage } from 'quasar'

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready (registration) {
    // console.log('Service worker is active.')
    const updateManual = () => {
      registration.update().catch((er) => console.error('Error on update worker', er))
    }
    setInterval(updateManual, 10000)
  },

  registered (/* registration */) {
    // console.log('Service worker has been registered.')
  },

  cached (/* registration */) {
    // console.log('Content has been cached for offline use.')
  },

  updatefound (registration) {
    console.error('New content is downloading.')

    const cacheNotif = document.createElement('div')
    cacheNotif.className = 'notif-head red'
    cacheNotif.id = 'cms-updated'
    cacheNotif.innerHTML = 'Versi CMS telah diperbarui, Klik area ini untuk "refresh" halaman atau ketikkan <strong>Ctrl+Shift+R</strong>'
    document.body.appendChild(cacheNotif)

    // Trigger Force Reload for other tab
    LocalStorage.set('force-reload-key', Math.random() * 1000)

    // Reset caches
    caches.keys()
      .then(keyList => {
        Promise.all(
          keyList.map(key => {
            return caches.delete(key)
          })
        )
      })

    // Refresh page
    document.getElementById('cms-updated')
      .addEventListener('click', (e) => {
        setTimeout(() => {
          location.reload(true)
        }, 500)
      })

    // registration.update().catch((er) => console.error('Error on update worker', er))
  },

  updated (/* registration */) {
    // console.error('New content is available; please refresh.')
  },

  offline () {
    // console.log('No internet connection found. App is running in offline mode.')
    const cacheNotif = document.createElement('div')
    cacheNotif.className = 'notif-head orange'
    cacheNotif.innerHTML = 'No internet connection found. App is running in offline mode.'
    document.body.appendChild(cacheNotif)
  },

  error (/* err */) {
    // console.error('Error during service worker registration:', err)
  }
})
